import styled from 'styled-components'

const FooterStyle = styled.div`
  min-height: 10vh;
  width: 100%;
  background-color: ${(props) => props.theme.background};
  display: flex;
  justify-content: space-between;
  padding: 1rem 2rem;
  align-items: flex-end;

  img {
    margin: 0 0.5rem;
  }

  @media (max-width: 768px) {
    .footer-info {
      width: 50%;
      margin-top: 1rem;
    }
    .sm-links {
      width: 50%;
      padding-left: 0.5rem;
    }
  }
`

export default FooterStyle
